import React from 'react';
import './PainPoints.css';

function PainPoints() {
  return (
    <div className="pain-points-container">
      <h2 className="pain-points-title">Sound Familiar?</h2>
      <div className="cards-container">
        <div className="pain-point-card">
          <h3>Tab Overload</h3>
          <p>You've got 27 browser tabs open and still can't find answers from people exactly like you.</p>
        </div>

        <div className="pain-point-card">
          <h3>Clinical ≠ Practical</h3>
          <p>Your doctor told you something about AMH; but you need to figure out if you're freezing eggs or embryos in your new relationship.</p>
        </div>

        <div className="pain-point-card">
          <h3>Group-Chat Guesswork</h3>
          <p>Friends are supportive— until you realize you're all equally confused.</p>
        </div>
      </div>
    </div>
  );
}

export default PainPoints; 